import { useDuplicateRecordingMutation } from '@carboncopyco/data';
import type { IRecording } from '@carboncopyco/types';
import { ConfirmAlert, notify } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';

interface DuplicateCloneModalProps {
  onClose: () => void;
  show: boolean;
  organizationId: string;
  cloneId: IRecording['id'];
  goToDuplicatedClone?: (clone: IRecording) => void;
}

export const DuplicateCloneModal = ({
  onClose,
  show,
  organizationId,
  cloneId,
  goToDuplicatedClone,
}: DuplicateCloneModalProps) => {
  const [duplicateClone, { isLoading }] = useDuplicateRecordingMutation();
  const [isDisabled, setIsDisabled] = useBoolean();

  return (
    <ConfirmAlert
      show={show}
      title="Duplicate this clone?"
      containerClass="w-ds-normal-modal"
      description="A new clone will be created as a copy of this one"
      noSecondButton
      onConfirm={() => {
        setIsDisabled.setTrue();
        duplicateClone({
          organizationId,
          id: Number(cloneId),
        })
          .unwrap()
          .then((newClone) => goToDuplicatedClone?.(newClone))
          .catch(() => notify.error('Error duplicating clone'))
          .finally(() => {
            setIsDisabled.setFalse();
            onClose();
          });
      }}
      yesLabel="Duplicate"
      onClose={onClose}
      loading={isLoading}
      disabled={isDisabled}
    />
  );
};
